import { APPOINTMENTS_STATUS } from '../../../../../services/appointments';

export const BadgeStatus = ({ status }) => {
  const getStatusClass = statusCode => {
    switch (statusCode) {
      case APPOINTMENTS_STATUS.COMPLETED:
        return 'today-status-badge active';
      case APPOINTMENTS_STATUS.CANCELED:
      case APPOINTMENTS_STATUS.NO_SHOW:
        return 'today-status-badge overdue';
      case APPOINTMENTS_STATUS.ASSIGNED:
        return 'today-status-badge assigned';
      case APPOINTMENTS_STATUS.REQUESTED:
        return 'today-status-badge requested';
      default:
        return 'today-status-badge';
    }
  };

  return (
    <span className={getStatusClass(status?.code)}>
      {status?.name?.toUpperCase()}
    </span>
  );
};
